import { useMutation } from "@apollo/client";
import { VerifyPromotionCodeMutationVariables } from "@ctypes";
import { VerifyPromotionCodeMutation } from "@ctypes/graphql";
import { VERIFY_PROMO_CODE } from "@graphql/mutations";
import { formatErrorMessage } from "@utils";

export const useVerifyPromotionCode = (variables?: VerifyPromotionCodeMutationVariables) => {
  const [verifyPromotionCode, { error, ...rest }] = useMutation<
    VerifyPromotionCodeMutation,
    VerifyPromotionCodeMutationVariables
  >(VERIFY_PROMO_CODE, {
    variables,
  });

  const errorMessage = formatErrorMessage(error?.graphQLErrors?.[0]?.message);

  return [verifyPromotionCode, { ...rest, error, errorMessage }] as const;
};
